import { Box, Button, Grid, Paper } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useMediaQueries } from '../usecontext/UseProvider';
import ImageUploadField from '../adminComponents/CommonTextField/ImageUploadField';
import CustomTextField from '../adminComponents/CommonTextField/CustomTextField';
import SuccessModal from '../adminComponents/successModal/SuccessModal';
import Header from '../adminComponents/header/Header';
import { useNavigate } from 'react-router-dom';
import { getContactUS, updateContactUS } from '../services/ConatactUs';

const validationSchema = Yup.object({
    title: Yup.string().required('The title field is required.'),
    description: Yup.string().required('The description field is required.'),
    image: Yup.mixed().required('The image field is required.d'),
    address: Yup.string().required('The location field is required.'),
    mobileNumber: Yup.string()
        .matches(/^\d{10}$/, 'Mobile number must be 10 digits')
        .required('The mobile number field is required.'),
    email: Yup.string().email('Invalid email').required('The email field is required.'),
    instagramLink: Yup.string().url('Invalid URL'),
    facebookLink: Yup.string().url('Invalid URL'),
    watsappNumber: Yup.string()
        .matches(/^\d{10}$/, 'WhatsApp number must be 10 digits')
        .required('The whatsapp number field is required.'),
});

const ContactUsmodal = () => {
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const navigate = useNavigate();
    const { contactUSData, setContactUSData } = useMediaQueries();

    const getContactUSData = async () => {
        try {
            const response = await getContactUS();
            setContactUSData(response?.contactUsData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getContactUSData();
    }, []);

    const formik = useFormik({
        initialValues: {
            title: contactUSData?.title || '',
            description: contactUSData?.description || '',
            image: contactUSData?.image || null,
            address: contactUSData?.address || '',
            mobileNumber: contactUSData?.mobileNumber || '',
            email: contactUSData?.email || '',
            instagramLink: contactUSData?.instagramLink || '',
            facebookLink: contactUSData?.facebookLink || '',
            watsappNumber: contactUSData?.watsappNumber || '',
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const formData = new FormData();
                
                // Append all form fields to FormData
                Object.keys(values).forEach(key => {
                    if (key === 'image') {
                        // Handle image file
                        if (values[key] instanceof File) {
                            formData.append('image', values[key]);
                        } else if (values[key]?.url) {
                            // If it's an existing image object, we don't need to send it
                            formData.append('image', '');
                        }
                    } else {
                        formData.append(key, values[key] || '');
                    }
                });

                const response = await updateContactUS(contactUSData?._id, formData);
                if (response?.status === 200) {
                    setSuccessModalOpen(true);
                    navigate('/admin/contact');
                }
            } catch (error) {
                console.error('Error updating contact:', error);
            }
        },
    });

    // Update form values when contactUSData changes
    useEffect(() => {
        if (contactUSData) {
            formik.setValues({
                title: contactUSData.title || '',
                description: contactUSData.description || '',
                image: contactUSData.image || null,
                address: contactUSData.address || '',
                mobileNumber: contactUSData.mobileNumber || '',
                email: contactUSData.email || '',
                instagramLink: contactUSData.instagramLink || '',
                facebookLink: contactUSData.facebookLink || '',
                watsappNumber: contactUSData.watsappNumber || '',
            });
        }
    }, [contactUSData]);

    const handleClose = () => {
        formik.resetForm();
        navigate('/admin/contact');
    };

    return (
        <>
            <Header title="Change image & text" />
            <Box sx={{ pt: 3 }}>
                <Paper sx={{ p: { sm: 5, xs: 3 } }}>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                                <ImageUploadField
                                    sx={{ mt: 2 }}
                                    label="Image"
                                    name="image"
                                    formik={formik}
                                    data={contactUSData}
                                    imageHeight='70px'
                                    imageWidth='70px'
                                />
                                <CustomTextField
                                    label="Title"
                                    name="title"
                                    formik={formik}
                                    placeholder="Enter Title"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                                <CustomTextField
                                    label="Description"
                                    name="description"
                                    formik={formik}
                                    placeholder="Enter Description"
                                    minRows={4}
                                    multiline={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CustomTextField
                                    label="Location"
                                    name="address"
                                    formik={formik}
                                    placeholder="Enter location"
                                    multiline={true}
                                />
                                <CustomTextField
                                    label="Mobile number"
                                    name="mobileNumber"
                                    formik={formik}
                                    placeholder="Enter mobile number"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                                <CustomTextField
                                    label="Email"
                                    name="email"
                                    formik={formik}
                                    placeholder="Enter email"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                                <CustomTextField
                                    label="Instagram link"
                                    name="instagramLink"
                                    formik={formik}
                                    placeholder="Enter intagram link"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                                <CustomTextField
                                    label="Facebook link"
                                    name="facebookLink"
                                    formik={formik}
                                    placeholder="Enter facebook link"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                                <CustomTextField
                                    label="Whats App number"
                                    name="watsappNumber"
                                    formik={formik}
                                    placeholder="Enter whats app number"
                                    size='small'
                                    sx={{ mt: 2 }}
                                />
                            </Grid>
                        </Grid>

                        {/* {error && (
                            <Typography color="error" variant='caption'>{error}</Typography>
                        )} */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 4 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    borderRadius: '10px',
                                    borderColor: '#01A0E2',
                                    color: '#000',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    borderRadius: '10px',
                                    backgroundColor: '#01A0E2',
                                    color: '#fff',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                            >
                                Submit
                            </Button>
                        </Box>
                    </form>
                </Paper>
            </Box>

            {/* Success Modal */}
            <SuccessModal
                open={successModalOpen}
                onClose={() => setSuccessModalOpen(false)}
                message={'Contact information updated successfully'}
            />
        </>
    )
}

export default ContactUsmodal
